import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { GbNotificationService } from '@galabid/shared/utils/notification'
import { LoginConstants } from 'libs/gb-dashboard/account/feature-auth/login/src/lib/login.constants'
import { GbDashboardAuthService } from '../gb-dashboard-auth-service/gb-dashboard-auth.service'
import { AuctionsConstants } from 'libs/gb-dashboard/auctions/feature/src/lib/auctions.constants'

@Injectable({
  providedIn: 'root',
})
export class IsAuthenticatedGuard {
  constructor(
    private router: Router,
    private gbNotificationService: GbNotificationService,
    private gbDashboardAuthService: GbDashboardAuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.gbDashboardAuthService.isAuthenticated()) return true

    this.gbNotificationService.error('AUTH.LOGIN.NOT_AUTHED_WARNING')

    let stateUrl = state.url
    if (stateUrl !== `/${AuctionsConstants.AUCTION}`) {
      // TODO: Remove this when the auction redirect is removed
      // This is a temporary fix to redirect from /auction/* to /campaign/*
      // to be removed once old dashboard has been retired.
      const subDomains = stateUrl.split('/').filter((subDomain) => subDomain !== '')
      if (subDomains.length > 0 && subDomains[0] === 'auction') {
        subDomains[0] = AuctionsConstants.AUCTION
        stateUrl = subDomains.join('/')
      }
      return this.router.createUrlTree([`${LoginConstants.LOGIN}`], { queryParams: { redirectUrl: stateUrl } })
    }
    return this.router.createUrlTree([`${LoginConstants.LOGIN}`])
  }
}
